import { css } from '@emotion/css';

export const headerIconStyles = css`
  ::after {
    border: none !important;
  }
`;
